import { useQueryClient } from '@tanstack/react-query';

import { useQuery } from '@hooks/reactQuery';

import { getAlarmHistory } from '@api/alarmHistory';

import { extractQueryParams } from '@utils/common';
import { formatDate } from '@utils/kpi-utils/date';

import { IAlarmInformation } from '@interfaces/alarms/alarm';
import { IAlarmByVendor } from '@interfaces/alarms/dto/alarmsDTO';

import { EVendorsValues } from '@enums/common';

import { formatTemplateDefault } from '@constants/common';
import { ALARM_HISTORY } from '@constants/queryKeys';

interface IUseQueryAlarmsFlexidasReturn {
	isLoading: boolean;
	data: IAlarmInformation[];
	countOfRecords: number;
	invalidateQuery: () => void;
}

export const useQueryAlarmHistory = (params: IAlarmByVendor): IUseQueryAlarmsFlexidasReturn => {
	const queryClient = useQueryClient();

	const {
		fromDate,
		toDate,
		vendor,
	} = params;

	const isEnabled = vendor === EVendorsValues.limenet;
	const { isEnabled: isEnabledTab, ...restParams } = params;

	const dto = {
		...restParams,
		vendor: undefined,
		fromText: fromDate ? formatDate(fromDate, formatTemplateDefault) : null,
		toText: toDate ? formatDate(toDate, formatTemplateDefault) : null,
	};

	const {
		data,
		isInitialLoading: isLoadingAlarmHistory,
	} = useQuery({
		queryKey: [ALARM_HISTORY, dto],
		queryFn: extractQueryParams(getAlarmHistory),
		enabled: [isEnabled, isEnabledTab],
		refetchOnWindowFocus: false,
	});

	const invalidateQuery = () => {
		return [queryClient.invalidateQueries([ALARM_HISTORY])];
	};

	return {
		data: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoading: isLoadingAlarmHistory,
		invalidateQuery,
	};
};
